import { ColorItem } from "./color-item";
import { HeartToggleButton } from "../save-color/heart-toggle-button";
import { SaveColorDropdown } from "../save-color/save-color-dropdown";
import { useMyLikedColorsStore } from "../../../js/stores/my-liked-colors-store";
import { addToBasketAction as basketFetchAction } from "../shared/add-to-basket-action";
import { TrendingBadge } from "./trending-badge";

export function LoggedOffColorItem({ name, rgb, colourCode, colourActions, isTrending }) {
  const removeColor = useMyLikedColorsStore((state) => state.removeColor);
  const toggleClickHandler = () => {
    removeColor(colourCode);
  };
  const addToBasketAction = colourActions?.addToBasketAction?.linkUrl
    ? {
        label: colourActions?.addToBasketAction?.linkLabel,
        clickHandler: () =>
          basketFetchAction(colourActions?.addToBasketAction?.linkUrl),
      }
    : null;
  const removeAction = {
    label: colourActions?.removeAction?.linkLabel,
    clickHandler: () => toggleClickHandler(),
  };
  const actions = [addToBasketAction, removeAction].filter(
    (action) => !!action
  );

  return (
    <ColorItem
      name={name}
      rgb={rgb}
      colourCode={colourCode}
      actions={
        <>
          <HeartToggleButton
            isSaved={true}
            toggleClickHandler={toggleClickHandler}
          />
          <SaveColorDropdown actions={actions} />
          {!!isTrending && <TrendingBadge />}
        </>
      }
    />
  );
}
